import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import ExecutiveDashboard from '../components/dashboard/ExecutiveDashboard';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import Button from '../components/ui/Button';
import Spinner from '../components/ui/Spinner';
import Alert from '../components/ui/Alert';

// Pagina „Conformitate firmă client" — accesibilă SSM-iștilor din portofoliu.
// Refolosește componenta ExecutiveDashboard cu prop-ul `companyId` pentru a încadra cererea pe
// firma client specifică (controllerul validează că firma e în portofoliul SSM-istului).
const CompanyCompliance = () => {
  const { t } = useTranslation();
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/companies/${companyId}`);
        if (!cancelled) setCompanyName(res.data?.name || '');
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.error || err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  if (loading) return <Spinner size="lg" label={t('common.loading')} />;
  if (error) return <Alert type="error">{error}</Alert>;

  return (
    <div className="space-y-4">
      <Breadcrumbs
        items={[
          { label: t('companyCompliance.breadcrumbPortfolio'), href: '/dashboard' },
          {
            label: companyName || t('companyCompliance.companyFallback'),
            href: `/companies/${companyId}`,
          },
          { label: t('companyCompliance.breadcrumbCompliance') },
        ]}
      />
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="page-title">{t('companyCompliance.title', { name: companyName })}</h1>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={() => navigate(`/companies/${companyId}`)}>
            {t('companyCompliance.companyDetails')}
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(`/companies/${companyId}/sheets`)}
          >
            {t('companyCompliance.employeeSheets')}
          </Button>
        </div>
      </div>
      <ExecutiveDashboard companyId={companyId} />
    </div>
  );
};

export default CompanyCompliance;
